import AccountPasswordSetScreen from "app/screens/authentication/AccountPasswordSetScreen";
import { ForceGuestGuard } from "app/features/authentication/guards/ForceGuestGuard";

export default function AccountSetPage() {
  return (
    <ForceGuestGuard>
      <AccountPasswordSetScreen />
    </ForceGuestGuard>
  );
}
